import { ButtonAlert } from 'components/ButtonAlert';
import { ConfirmationDialog } from 'components/ConfirmationDialog';
import { RequestStatus } from 'features/request/requestSlice';
import { ProjectStatusEnum } from 'gql/graphql';
import { useAccess } from 'hooks/useAccess';
import { useMethodsProjectDelete } from 'hooks/useMethodsProjectDelete';
import { cnMixSpace } from 'uikit';

import type React from 'react';
import { useMemo } from 'react';

interface IProjectDeleteProps {
    isDisabled?: boolean;
    projectId?: string;
    statusProject?: ProjectStatusEnum;
    isOpenTooltipDelete?: boolean;
    textTooltipDelete?: string;
}

export const ProjectDelete: React.FC<IProjectDeleteProps> = (props) => {
    const { projectId, isDisabled, statusProject, isOpenTooltipDelete, textTooltipDelete } = props;
    const { project: projectRules } = useAccess();
    const { isConfirmationDialogOpen, handleCloseDeleteDialog, deleteStatus, handleDeleteExactly, handleDeleteBtn } =
        useMethodsProjectDelete(projectId);

    const isDeleteDisabled = useMemo(() => {
        const isProjectStatusDelayed = statusProject === ProjectStatusEnum.Delayed;
        const isProjectStatusCompleted = statusProject === ProjectStatusEnum.Completed;

        return (
            deleteStatus === RequestStatus.FETCHING ||
            isDisabled ||
            !projectRules.canDelete ||
            isProjectStatusDelayed ||
            isProjectStatusCompleted
        );
    }, [deleteStatus, isDisabled, projectRules.canDelete, statusProject]);

    return (
        <>
            <ButtonAlert
                label="Удалить проект"
                size="s"
                onClick={handleDeleteBtn}
                className={cnMixSpace({ mL: 's' })}
                loading={deleteStatus === RequestStatus.FETCHING}
                disabled={isDeleteDisabled}
                isOpenTooltip={isOpenTooltipDelete}
                textTooltip={textTooltipDelete}
            />
            <ConfirmationDialog
                textHeader="УДАЛЕНИЕ ПРОЕКТА"
                textConfirmation="Вы уверены, что хотите удалить текущий проект?"
                isOpened={isConfirmationDialogOpen}
                onSubmit={handleDeleteExactly}
                onClose={handleCloseDeleteDialog}
                cancelButtonText="Не удалять"
                confirmButtonText="Удалить"
            />
        </>
    );
};

ProjectDelete.displayName = 'ProjectDelete';
